import { Injectable } from "@angular/core";
import { Observable, Subscription, merge, fromEvent, timer, BehaviorSubject } from "rxjs";
import * as moment from "moment";
import { UserStorageService } from "../local/user-storage.service";
import { Router } from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class LockSessionService {
    private events$!: Observable<any>;
    private timer$!: Subscription;
    private timerSessionEnd$!: Subscription;

    public timeOut!: moment.Duration;
    public timeOutEndSession!: moment.Duration;
    private eventSubscription!: Subscription;
    public expired$ = new BehaviorSubject<boolean>(false);
    
    constructor(
        private userStorageService: UserStorageService,
        private router : Router
        ) {
        
        this.timeOut = moment.duration(userStorageService.getTimeOut());
        this.timeOutEndSession = moment.duration(userStorageService.getEndTimeBlockedSession());
    }

    public detectInactivity(): Observable<any> {
        
        this.finalizeLock();
        this.events$ = merge(    
            fromEvent(document, 'mousemove'),
            fromEvent(document, 'click'),
            fromEvent(document, 'mousedown'),
            fromEvent(document, 'keypress'),
            fromEvent(document, 'DOMMouseScroll'),
            fromEvent(document, 'mousewheel'),
            fromEvent(document, 'touchmove'),
            fromEvent(document, 'MSPointerMove'),
        );

        this.eventSubscription = this.events$.subscribe((res) => {
            this.activityDetected();
        });

        this.startTimer();
        return this.expired$;
    }    

    public activityDetected() {
        this.timer$.unsubscribe();
        this.startTimer();
    }
    
    public finalizeLock() {
        
        if(this.timer$){
            this.timer$.unsubscribe();
        }
        if(this.eventSubscription){
            this.eventSubscription.unsubscribe();
        }
        this.expired$ = new BehaviorSubject<boolean>(false);
    }

    private startTimer() {
        this.timer$ = timer(this.timeOut.asMilliseconds()).subscribe((res) => {
            
            this.expired$.next(true);
            this.userStorageService.setLock(true);
            this.eventSubscription.unsubscribe();
            this.timer$.unsubscribe();
            this.startEndTimer();
        });
    }
    public startEndTimer(){
        
        this.timerSessionEnd$ = timer(this.timeOutEndSession.asMilliseconds()).subscribe((res) => {
            
            this.userStorageService.logout();
		    this.finalizeLock();
      	    this.router.navigate(['/']);
            this.timerSessionEnd$.unsubscribe();
        });
    }
    public stopEndTimer(){
        if(this.timerSessionEnd$){
            this.timerSessionEnd$.unsubscribe();
        }
    }
}